<template>
  <div class="white-wrapper">
    <main-header />
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.white-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
</style>
